import React from 'react';
import PropTypes from 'prop-types';

const EmailForm = ({
  renderValidationError,
  authenticityToken,
  handleSubmit,
  onChange,
  formAction,
  newUserConfimationPath,
  newUserPasswordPath,
  buttonText,
  buttonEnabled,
  attribute
}) => (
  <form
    method="POST"
    action={formAction}
    className="form"
    acceptCharset="UTF-8"
    onSubmit={handleSubmit}
    id="email-form"
  >
    <input name="utf8" type="hidden" value="✓" />
    <input
      type="hidden"
      name="authenticity_token"
      value={authenticityToken}
    />

    <div className="flex flex-wrap clearfix">
      <div className="flex-auto mt1 email-wrapper">
        <input
          type="text"
          className="input input-pill"
          name={"user[" + (attribute || 'email') + "]"}
          placeholder="Email"
          id="email"
          is-required="true"
          onChange={onChange}
        />
        {renderValidationError('email')}
      </div>
      <div className="mt1 px1 button-wrapper">
        <button
          type="submit"
          className="btn-pill btn btn-primary"
          disabled={!buttonEnabled}
        >
          { buttonText }
        </button>
      </div>
      <div className="col col-12 md-col-12 mt1 px1 bottom-links">
        {
          newUserPasswordPath &&
          <a className="block mb2" href={newUserPasswordPath}>Forgot your password?</a>
        }
        {
          newUserConfimationPath &&
          <a href={newUserConfimationPath}>Didn't receive confirmation instructions?</a>
        }
      </div>
    </div>
  </form>
);

EmailForm.propTypes = {
  renderValidationError: PropTypes.func.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  formAction: PropTypes.string.isRequired,
  newUserConfimationPath: PropTypes.string.isRequired,
  newUserPasswordPath: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonEnabled: PropTypes.bool.isRequired,
  attribute: PropTypes.string
};
export default EmailForm;
